import React from 'react'
import AuthorProfile from './AuthorProfile'
import Delta from './Delta'
import EndBar from './EndBar'
import Comments from './Comments'
/* REDUX */
import { connect } from 'react-redux'
import { loadReport } from '../../actions/report'

const loadData = ({ report_id, loadReport }) => {
	loadReport(report_id)
}

class Content extends React.Component {
	
	componentWillMount() {
		loadData(this.props)
	}
	
	componentWillReceiveProps(nextProps) {
		if (nextProps.report_id !== this.props.report_id) {
			loadData(nextProps)
		}
	}
	
	render() {
		
		const { pathname, report } = this.props
				
		if (!report) {
			return <div></div>
		}
		
		const { title } = report
				
		return (
			<section className="content bg-white">
				<div className="report">
					<div className="container">
						<div className="row">
							<div className="col-12 offset-md-1 col-md-10 offset-lg-2 col-lg-8">
								<AuthorProfile {...pathname} onLogin={ this.props.onLogin } />
								<div className="article">
									<h1 className="title">{ title }</h1>
									<Delta {...pathname} />
								</div>
								<EndBar {...pathname} onLogin={ this.props.onLogin } />
								<Comments {...pathname} onLogin={ this.props.onLogin } />
							</div>
						</div>
					</div>
				</div>
			</section>
		)
	}
}

const mapStateToProps = (state, ownProps) => {
	const report_id = ownProps.pathname.params.report_id
	const {
		reportById
	} = state
	const reportWrapper = reportById[report_id] || {}
	const report = reportWrapper.report
	return {
		report_id,
		report
	}
}

export default connect(mapStateToProps, { loadReport })(Content)


// WEBPACK FOOTER //
// ./src/components/Report/Content.js